<template>
    <div>
        <vx-card id="subscriberDiv"  class="vs-con-loading__container xl:w-1/3 lg:w-1/2 w-full">
            <div v-if="!editEnabled">
                <table class="simple-table mt-6" >
                    <tr>
                        <td class="font-semibold">ERP Reference Id:</td>
                        <td>{{ subscriber.erp_reference_id }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">Name:</td>
                        <td>{{ subscriber.name }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">Email:</td>
                        <td>{{ subscriber.email }}</td>
                    </tr>
                </table>
                <h6>Additional notes</h6>
                <p style="white-space: pre-line">
                    {{subscriber.additional_notes}}
                </p>
            </div>
            <div v-else>
                <p class="mt-6">ERP Reference Id</p>
                <vs-input v-model="editObject['erp_reference_id']" class="w-full"></vs-input>
                <p class="mt-6">Name</p>
                <vs-input v-model="editObject['name']" class="w-full"></vs-input>
                <p class="mt-6">Email</p>
                <vs-input v-model="editObject['email']" class="w-full"></vs-input>
                <p class="mt-6">Connections</p>
                <vs-textarea v-model="editObject['additional_notes']" class="w-full"></vs-textarea>
            </div>

            <vs-divider/>

            <vs-button style="float: left" icon-pack="feather" icon="icon-edit" v-if="!editEnabled" color="warning" class="mt-6; mr-1" @click="editEnabled = true">Edit</vs-button>
            <vs-button style="float: left" icon-pack="feather" icon="icon-check-circle" v-if="!subscriber.custom_stb_config_enabled" color="warning" class="mt-6; mr-1" @click="enableCustomSTBConfig">Enable custom STB config</vs-button>
            <vs-button style="float: left" icon-pack="feather" icon="icon-x" v-if="subscriber.custom_stb_config_enabled" color="danger" class="mt-6; mr-1" @click="disableCustomSTBConfig">Disable custom STB config</vs-button>
            <vs-button style="float: left" icon-pack="feather" icon="icon-save" v-if="editEnabled" color="success" class="mt-6; mr-1" @click="saveSubscriber">Save</vs-button>
            <vs-button style="float: left" icon-pack="feather" icon="icon-x" v-if="editEnabled" color="warning" class="mt-6; mr-1" @click="editEnabled = false">Cancel</vs-button>
            <vs-button style="float: right" icon-pack="feather" icon="icon-trash-2" v-if="editEnabled" color="danger" class="mt-6; mr-1" @click="removeSubscriber">Remove</vs-button>
            <div style="clear: both"></div>
        </vx-card>

        <STBConfig class="mt-6" v-if="subscriber.custom_stb_config_enabled" :subscriber-id="Number(this.$route.params.id)"/>
    </div>
</template>
<script>

import STBConfig from '@/views/STBConfig/STBConfig'
export default {
    components: { STBConfig },
    data(){
        return {

            subscriber: {
                erp_reference_id: 0,
                name: '',
                email: '',
                additional_notes: '',
                custom_stb_config_enabled: false
            },

            editEnabled: false,
            editObject: {},

        }
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#subscriberDiv',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this
            const loadPromise = this.$http.get('/api/management/v1/subscriber/' + this.$route.params.id)
            loadPromise.then(function(response) {
                thisIns.subscriber = response.data;
                thisIns.editObject = JSON.parse(JSON.stringify(response.data));
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function() {
                thisIns.$vs.loading.close('#subscriberDiv > .con-vs-loading')
            })
        },
        saveSubscriber() {
            this.$vs.loading({
                container: '#subscriberDiv',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this
            const savePromise = this.$http.put('/api/management/v1/subscriber/' + this.$route.params.id, {
                erp_reference_id: Number(this.editObject.erp_reference_id),
                name: this.editObject.name,
                email: this.editObject.email,
                additional_notes: this.editObject.additional_notes,
            })

            savePromise.then(function() {
                thisIns.$printSuccess('Subscriber saved')
                thisIns.editEnabled = false
                thisIns.loadData()
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function() {
                thisIns.$vs.loading.close('#subscriberDiv > .con-vs-loading')
            })
        },
        removeSubscriber() {
            const thisIns = this
            const removePromise = this.$http.delete('/api/management/v1/subscriber/' + this.$route.params.id)
            removePromise.then(function() {
                thisIns.$printSuccess('Subscriber removed')
                thisIns.$nextTick(() => {
                    thisIns.$router.push('/subscribers')
                })
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            })
        },
        enableCustomSTBConfig() {
            const thisIns = this
            const removePromise = this.$http.put('/api/management/v1/subscriber/' + this.$route.params.id + "/custom_stb_config/enable")
            removePromise.then(function() {
                thisIns.$printSuccess('Custom STB config enabled')
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function(){
                thisIns.loadData()
            })
        },
        disableCustomSTBConfig() {
            const thisIns = this
            const removePromise = this.$http.put('/api/management/v1/subscriber/' + this.$route.params.id + "/custom_stb_config/disable")
            removePromise.then(function() {
                thisIns.$printSuccess('Custom STB config enabled')
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function(){
                thisIns.loadData()
            })
        }
    },
    mounted() {
        this.loadData()
    }
}

</script>

<style lang="scss" scoped>
.simple-table {
    td {
        vertical-align: top;
        min-width: 250px;
        padding-bottom: 1.3rem;
        word-break: break-all;

        @media screen and (max-width:370px) {
            display: block;
        }
    }
}

</style>
